module.exports = __webpack_public_path__ + "伍鸣-90fbccb6.png";